import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap, selectExperimentsFromBootstrap, selectGeoFromBootstrap } from 'store/slice/bootstrap';
import { CmsValue, Geo } from 'core/type/BootstrapConfig.types';
import { selectFilteredActivitiesFromSearchState } from 'component/page/search/store/search.selectors';
import { selectScreenSize } from 'store/slice/screen';
import { selectNavigationState, setLocationSearch, setLocationSearchWithNavigation } from 'store/slice/navigation';
import { QueryString } from 'core/utils/queryString/queryString';
import { fetchActivities } from 'component/page/search/store/search';
import { SearchQueryKey } from 'core-framework/constant/SearchQueryKey';
import { NavigationState } from 'store/slice';
import { NavigateFunction } from 'react-router-dom';
import { isB } from 'core/window/bootstrapConfig';
import { ExperimentId } from 'core/type/ExperimentId';

interface OwnProps {
    keyword: string;
}

interface StateProps {
    cms: CmsValue;
    totalActivities: number;
    isMobile: boolean;
    navigation: NavigationState;
    geo?: Geo;
    isAct4518: boolean;
}

interface DispatchProps {
    onDismissKeyword: (location: string, isAct4518: boolean, navigate: NavigateFunction) => void;
}

export type InCitySearchFilterContentProps = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectFilteredActivitiesFromSearchState,
    selectGeoFromBootstrap,
    selectScreenSize,
    selectNavigationState,
    selectExperimentsFromBootstrap,
    (cms, totalActivities, geo, screenSize, navigation, experiments): StateProps => {
        return {
            cms,
            totalActivities,
            geo,
            navigation,
            isAct4518: isB(ExperimentId.ACT_4518, experiments),
            isMobile: screenSize.mobile,
        };
    },
);

export const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    onDismissKeyword: (locationSearch: string, isAct4518: boolean, navigate: NavigateFunction) => {
        if (!locationSearch) return;
        const query = new QueryString(locationSearch);
        if (query.have(SearchQueryKey.Keyword)) {
            query.delete(SearchQueryKey.Keyword);
            query.set(SearchQueryKey.PageNumber, '1'); // redirect to first page
            if (isAct4518) dispatch(setLocationSearchWithNavigation({ query: query.toString(), addToHistory: true, navigate }));
            else dispatch(setLocationSearch({ query: query.toString(), addToHistory: true }));
            fetchActivities(1); // 1 for resetting the page number
        }
    },
});
